module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_7016.3d4284be.png";